import { render, staticRenderFns } from "./SimpleDeleteButton.vue?vue&type=template&id=3e5108ab&scoped=true&"
import script from "./SimpleDeleteButton.vue?vue&type=script&lang=js&"
export * from "./SimpleDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDeleteButton.vue?vue&type=style&index=0&id=3e5108ab&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5108ab",
  null
  
)

export default component.exports